import { BrowserSession, initializeSdk, UcsSdk } from '@brandfolder/ucs-sdk-browser';
import React, { FC, useEffect, useState } from 'react';

import { UppyUcsUploader } from './UppyUCSUploader';
import fetchJson  from '@api/api_helper';
import { UppyUploaderProps } from '../types/UppyTypes';

const fetchBoulderUcsBrowserSession = async (options: {
  bearerToken: string;
  url: string;
}): Promise<BrowserSession> => {

  try {
    const response = await fetchJson(options.url, {
      method: 'POST',
      queuePriorityHigh: false,
      body: {
        brandfolder_key: BFG.brandfolder_key,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${options.bearerToken}`,
      },
    });
    if (!response) {
      throw new Error(`Failed to create browser session: ${response}`);
    }

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const UppyTusWrapper: FC<UppyUploaderProps> = (uppyProps) => {
  const [endpoint, setEndpoint] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [ucsSdkInstance, setUcsSdkInstance] = useState<UcsSdk>(null);
  const bearerToken = BFG.BF_Token

  useEffect(() => {
    const initializeTusEndpoint = async () => {
      try {
        if (!bearerToken) {
          throw new Error('Either bearerToken or isFl2 flag is required');
        }

        setIsLoading(true);
        setError(null);


        const ucsSdk = initializeSdk({
          createBrowserSessionFunction(): Promise<BrowserSession> {
            return fetchBoulderUcsBrowserSession({
              bearerToken,
              url: `${BFG.domain}/api/v4/ucs/v2/browser_session`
            });
          }
        });

        let ucsTusUrl = '';
        try {
          ucsTusUrl = (await ucsSdk.getTusUrl()) || '';
          setUcsSdkInstance(ucsSdk);
          setEndpoint(ucsTusUrl);
        } catch (error) {
          console.error('Failed to get TUS URL:', error);
        }


      } catch (err) {
        console.error('Failed to initialize TUS endpoint:', err);
        setError(err instanceof Error ? err.message : 'Unknown error occurred');
      } finally {
        setIsLoading(false);
      }
    };

    initializeTusEndpoint();
  }, [bearerToken]);

  if (isLoading) {
    return <div>Loading uploader...</div>;
  }

  if (error) {
    return <div>Error initializing uploader: {error}</div>;
  }

  if (!endpoint) {
    return <div>Unable to initialize uploader endpoint</div>;
  }

  return <UppyUcsUploader {...uppyProps} endpoint={endpoint} ucsSdk={ucsSdkInstance} />;
};
